__webpack_require__.p = "/storybook-prosemirror-docs-update/onboarding/";